import { type ConfigData } from "./config-data";

/**
 * Helper function to assist IDE with completion and type-checking.
 *
 * @public
 * @since
 */
export function defineConfig(config: ConfigData): ConfigData {
	return config;
}
